export default function AboutSection() {
  return (
    <section id="about" className="py-32 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/06a99a5bab3049dde7e6c8e7591741c7.jpg"
                alt="영화 신공 컨셉 이미지"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="absolute top-6 left-6 flex gap-3">
              <span className="px-4 py-2 bg-white/20 backdrop-blur-md text-white text-sm font-medium rounded-full border border-white/30">
                액션
              </span>
              <span className="px-4 py-2 bg-white/20 backdrop-blur-md text-white text-sm font-medium rounded-full border border-white/30">
                느와르
              </span>
              <span className="px-4 py-2 bg-white/20 backdrop-blur-md text-white text-sm font-medium rounded-full border border-white/30">
                판타지
              </span>
            </div>
          </div>
          
          <div className="space-y-8">
            <div>
              <p className="text-amber-600 text-sm font-semibold tracking-wider uppercase mb-4">
                ABOUT THE FILM
              </p>
              <h2 
                className="text-5xl font-black text-gray-900 leading-tight"
                style={{ fontFamily: "'Noto Serif KR', serif" }}
              >
                영화 <span className="text-amber-600">[신공]</span>은
              </h2>
            </div>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-lg">
                현대 사회의 부조리 속에서 진정한 정의를 찾아 나서는 한 영웅의 서사를 담은 <strong>액션/느와르/판타지</strong> 장르의 영화입니다.
              </p>
              
              <div className="bg-gray-900 rounded-2xl p-8 text-white">
                <h3 className="text-xl font-bold mb-4 text-amber-400">기획 의도</h3>
                <p className="leading-relaxed text-gray-300">
                  우리는 익명성과 무관심 속에 묻혀버린 '작은 영웅들의 희생'에 주목합니다. [신공]은 시스템에 맞서 싸우는 주인공을 통해, 관객들에게 <strong className="text-white">"만약 나에게 초인적인 능력이 있다면 무엇을 할 것인가?"</strong>라는 강력한 질문을 던집니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
